import { render, staticRenderFns } from "./commentList.vue?vue&type=template&id=13d8b759&scoped=true"
import script from "./commentList?vue&type=script&lang=js&external"
export * from "./commentList?vue&type=script&lang=js&external"
import style0 from "./commentList.vue?vue&type=style&index=0&id=13d8b759&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d8b759",
  null
  
)

export default component.exports